import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { TenantAuthClaims } from '@models';
import { Observable, catchError, first, from, of, switchMap } from 'rxjs';

/**
 * Guard that only allows access to users with superAdmin: true in their JWT.
 * Used to protect the platform-level management section.
 */
export function superAdminGuard(): CanActivateFn {
  return (): Observable<boolean | import('@angular/router').UrlTree> => {
    const auth = inject(Auth);
    const router = inject(Router);

    return authState(auth).pipe(
      first(),
      catchError(() => of(null)),
      switchMap((user) => {
        if (!user) return of(router.createUrlTree(['/login']));

        return from(user.getIdTokenResult()).pipe(
          switchMap((tokenResult) => {
            const claims = tokenResult.claims as unknown as TenantAuthClaims;
            if (claims?.superAdmin === true) return of(true);
            return of(router.createUrlTree(['/dashboard']));
          }),
          catchError(() => of(router.createUrlTree(['/login']))),
        );
      }),
    );
  };
}
